<template>
  <div class="pt-video-carousel">
    <span v-if="title" class="pt-video-carousel__title" v-text="title" />
    <div class="pt-video-carousel__wrapper">
      <div
        class="pt-video-carousel__container"
        :class="
          videos.length < 3
            ? 'pt-video-carousel__container--responsive'
            : 'pt-video-carousel__container--grid'
        "
      >
        <template v-for="(video, indexVideo) in setterItems(videos)" :key="indexVideo">
          <div
            :class="[
              'pt-video-carousel__video',
              {
                [`${indexVideo ? `hidden${indexVideo > 1 ? ' lg:block' : ' md:block'}` : ''}`]:
                  !windowWidth
              },
              indexVideo < numbersVideos.max && indexVideo >= numbersVideos.min
                ? 'activated'
                : 'disabled'
            ]"
          >
            <VideoCard
              class="pt-video-carousel__video-media"
              size="xs"
              dir="row"
              :url="video.url"
              :media="video.media"
              @show-video="onShowVideo"
            />
            <span class="pt-video-carousel__video-title" v-text="video.title" />
          </div>
        </template>
      </div>
      <div v-if="videos.length > 3 || (!lg && !md)" class="pt-video-carousel__icon">
        <icon
          :class="{ disabled: !numbersVideos.left }"
          name="pt-angle-left-b"
          @click="changeVideos('-')"
        />
        <icon
          :class="{ disabled: !numbersVideos.right }"
          name="pt-angle-right-b"
          @click="changeVideos('+')"
        />
      </div>
    </div>
    <VideoPlayer ref="videoPlayer" id-player="carousel-video" />
  </div>
</template>

<script>
import { RETRIEVE_INDEXES } from '~/utils/enums';
import VideoCard from '@/components/Cards/Video';
import VideoPlayer from '@/components/VideoLibrary/Player';
export default {
  name: 'PtVideoCarousel',
  components: {
    VideoCard,
    VideoPlayer
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    videos: {
      type: Array,
      default: () => []
    }
  },
  data() {
    const { windowWidth } = useWindow();
    const { lg, md } = useBreakpoints();
    return {
      RETRIEVE_INDEXES,
      numbersVideos: { max: 3, min: 0, left: false, right: true },
      lg,
      md,
      windowWidth
    };
  },
  computed: {
    numbersVideosStep() {
      if (this.windowWidth >= 1280) return 3;
      else if (this.windowWidth >= 768) return 2;
      else return 1;
    }
  },
  watch: {
    windowWidth() {
      this.numbersVideos.max = this.numbersVideosStep;
      this.numbersVideos.min = 0;
    }
  },
  methods: {
    setterItems(items) {
      const videos = items.slice(
        this.numbersVideos.min + this.numbersVideosStep,
        this.numbersVideos.max + this.numbersVideosStep
      );
      if (videos.length) this.numbersVideos.right = true;
      else this.numbersVideos.right = false;
      if (this.numbersVideos.min) this.numbersVideos.left = true;
      else this.numbersVideos.left = false;
      return items;
    },
    changeVideos(operation) {
      if (operation === '-' && this.numbersVideos.left) {
        this.numbersVideos.max -= this.numbersVideosStep;
        this.numbersVideos.min -= this.numbersVideosStep;
      } else if (operation === '+' && this.numbersVideos.right) {
        this.numbersVideos.max += this.numbersVideosStep;
        this.numbersVideos.min += this.numbersVideosStep;
      }
    },
    onShowVideo(url) {
      this.$nextTick(() => this.$refs.videoPlayer.openPlayer(url));
    }
  }
};
</script>

<style src="./style.scss" lang="scss"></style>
